import React from 'react';

export default function Car(props) {
  return (
    <svg id="Car" xmlns="http://www.w3.org/2000/svg" width="59.933" height="30.696" viewBox="0 0 59.933 30.696" fill={props.fill ? props.fill : '#5e72e4'}>
      <path
        id="Path_445"
        data-name="Path 445"
        d="M886.649,285.047c-6.019-2.643-25.96-11.328-29.872-12.134a33.831,33.831,0,0,0-6.8-.693,25.878,25.878,0,0,0-17.591,6.873l-3.308,3.051-.057.055a2.647,2.647,0,0,0-.722,1.82v10.216a1.137,1.137,0,1,0,2.274,0V284.019a.38.38,0,0,1,.086-.24l3.269-3.014a23.611,23.611,0,0,1,16.049-6.27,31.5,31.5,0,0,1,6.341.647c2.935.6,17.12,6.589,29.417,11.989a.37.37,0,0,1,.224.345v.195H883a1.744,1.744,0,0,0-1.743,1.742v.776a2.34,2.34,0,0,0,1.231,2.067l3.443,2.1a.376.376,0,0,1-.354.255H882.1a1.137,1.137,0,1,0,0,2.274h3.482a2.656,2.656,0,0,0,2.653-2.653v-6.761A2.649,2.649,0,0,0,886.649,285.047Zm-3.074,5.209a.075.075,0,0,1-.041-.068v-.245h2.425v1.766l-2.312-1.413Zm-11.519-.527a6.594,6.594,0,1,0,6.593,6.594A6.6,6.6,0,0,0,872.056,289.728Zm0,10.913a4.32,4.32,0,1,1,4.319-4.319A4.324,4.324,0,0,1,872.056,300.642Zm-9.855-5.456H846.564a6.593,6.593,0,1,0,0,2.274H862.2a1.137,1.137,0,0,0,0-2.274Zm-22.126,5.456a4.32,4.32,0,1,1,4.319-4.319A4.324,4.324,0,0,1,840.075,300.642Zm-.334-16.242a1.137,1.137,0,0,1,0-2.274h25.9a1.145,1.145,0,0,1,1.147,1.105,1.128,1.128,0,0,1-1.063,1.166l-.083,0Z"
        transform="translate(-828.3 -272.22)"
      />
    </svg>
  );
}

export function SUV(props) {
  return (
    <svg id="SUV" xmlns="http://www.w3.org/2000/svg" width="66.373" height="31.667" viewBox="0 0 66.373 31.667" fill={props.fill ? props.fill : '#5e72e4'}>
      <path
        id="Path_442"
        data-name="Path 442"
        d="M725.163,283.278l-11.631-1.94a.378.378,0,0,1-.129-.047l-9.909-10.1-.11-.1a2.646,2.646,0,0,0-1.625-.561H665.807a2.418,2.418,0,0,0-2.086,1.263,2.6,2.6,0,0,0,.028,2.585l1.037,1.745a1.13,1.13,0,1,0,1.942-1.155l-1.037-1.745a.333.333,0,0,1,0-.328.164.164,0,0,1,.157-.1H701.76a.376.376,0,0,1,.191.052l9.909,10.1.111.1a2.589,2.589,0,0,0,1.15.516l11.63,1.939a.376.376,0,0,1,.315.372v.609h-2.938a1.735,1.735,0,0,0-1.733,1.733v.771a2.325,2.325,0,0,0,1.224,2.054l3.446,2.106v1a.377.377,0,0,1-.377.377H719.5a6.554,6.554,0,1,0,0,2.26h5.189a2.64,2.64,0,0,0,2.637-2.637v-8.271A2.616,2.616,0,0,0,725.163,283.278Zm-12.112,16.664a4.294,4.294,0,1,1,4.294-4.294A4.3,4.3,0,0,1,713.051,299.942Zm9.718-10.851-.072-.041a.074.074,0,0,1-.042-.067v-.244h2.411v1.755Zm-52.583-10.347-6.867,8.7a.374.374,0,0,0-.106.261v6.433a.377.377,0,0,0,.377.377h3.759a1.13,1.13,0,1,1,0,2.26H663.59a2.64,2.64,0,0,1-2.637-2.637v-6.433a2.623,2.623,0,0,1,.694-1.782l6.765-8.58a1.13,1.13,0,1,1,1.774,1.4Zm33.07,15.774H683.947a6.554,6.554,0,1,0,0,2.26h19.309a1.13,1.13,0,1,0,0-2.26ZM677.5,299.942a4.294,4.294,0,1,1,4.293-4.294A4.3,4.3,0,0,1,677.5,299.942Zm13.658-18.934h11.56l-3.24-3.134a1.13,1.13,0,1,1,1.571-1.624l3.434,3.323a2.177,2.177,0,0,1,.5,2.373,2.042,2.042,0,0,1-1.888,1.322h-11.94a1.13,1.13,0,0,1,0-2.26Zm-16.036,2.26a1.13,1.13,0,1,1,0-2.26h8.58a.377.377,0,0,0,.377-.377v-3.569a1.13,1.13,0,1,1,2.26,0v3.569a2.639,2.639,0,0,1-2.637,2.637Z"
        transform="translate(-660.953 -270.535)"
      />
    </svg>
  );
}

export function Truck(props) {
  return (
    <svg id="Truck" xmlns="http://www.w3.org/2000/svg" width="81.037" height="35.331" viewBox="0 0 88.037 34.331" fill={props.fill ? props.fill : '#5e72e4'}>
      <path
        id="Path_443"
        data-name="Path 443"
        d="M499.433,293.193a1.2,1.2,0,0,1-1.2,1.2H489.31a2.8,2.8,0,0,1-2.8-2.8v-1.158h-.4a.4.4,0,0,0-.4.4v2.093a1.2,1.2,0,0,1-2.4,0v-2.093a2.8,2.8,0,0,1,2.8-2.8h7.615a1.2,1.2,0,0,1,0,2.4H488.91v1.158a.4.4,0,0,0,.4.4h8.925A1.2,1.2,0,0,1,499.433,293.193ZM564.354,280.1v11.5a2.8,2.8,0,0,1-2.8,2.8h-4.638a1.2,1.2,0,1,1,0-2.4h4.638a.4.4,0,0,0,.4-.4v-2.759a1.138,1.138,0,0,1-.167-.073l-4.228-2.584a2.467,2.467,0,0,1-1.3-2.179v-.818a1.84,1.84,0,0,1,1.839-1.838h3.856V280.1a.4.4,0,0,0-.327-.392l-13.114-2.876a2.761,2.761,0,0,1-1.429-.764l-9.144-9.145a.4.4,0,0,0-.283-.117H522.7a.4.4,0,0,0-.4.4v7.651a2.8,2.8,0,0,1-2.8,2.8h-30.2a.4.4,0,0,0-.4.4v7.089a1.2,1.2,0,0,1-2.4,0v-7.089a2.8,2.8,0,0,1,2.8-2.8h30.2a.4.4,0,0,0,.4-.4V267.2a2.8,2.8,0,0,1,2.8-2.8H537.66a2.779,2.779,0,0,1,1.978.819l9.143,9.143a.4.4,0,0,0,.21.111l13.114,2.875A2.786,2.786,0,0,1,564.354,280.1Zm-2.4,5.958v-2.315h-3.3V284a.08.08,0,0,0,.044.071l.077.043Zm-7.715,6.732a6.951,6.951,0,1,1-6.951-6.952A6.958,6.958,0,0,1,554.242,292.788Zm-2.4,0a4.554,4.554,0,1,0-4.554,4.554A4.559,4.559,0,0,0,551.845,292.788Zm-13.745,0a1.2,1.2,0,0,1-1.2,1.2H514.823a6.952,6.952,0,1,1,0-2.4H536.9A1.2,1.2,0,0,1,538.1,292.788Zm-25.563,0a4.554,4.554,0,1,0-4.554,4.554A4.559,4.559,0,0,0,512.537,292.788Zm29.125-16.252a2.307,2.307,0,0,0-.533-2.516l-3.644-3.525a1.2,1.2,0,0,0-1.667,1.723l3.437,3.324H526.994a1.2,1.2,0,0,0,0,2.4h12.665A2.166,2.166,0,0,0,541.662,276.536Z"
        transform="translate(-482.317 -264.408)"
      />
    </svg>
  );
}

export function TowTruck(props) {
  return (
    <svg id="Tow_Truck" data-name="Tow Truck" xmlns="http://www.w3.org/2000/svg" width="81.887" height="45.483" viewBox="0 0 800 530" fill={props.fill ? props.fill : '#5e72e4'}>
      <g transform="scale(-1 1) translate(-786.1 -50)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M74,424.87H26.57c-3.92,0-7.11-3.19-7.11-7.11v-30.4c1.09-0.2,2.16-0.52,3.16-1.13l43.3-26.47
		c7.26-3.89,11.76-11.39,11.76-19.66v-8.36c0-8.7-7.07-15.77-15.77-15.77H19.47v-15.76c0-3.42,2.45-6.36,6.11-7.04l133.4-29.27
		c5.11-0.95,9.75-3.39,13.42-7.06l93.49-93.49c1.34-1.34,3.13-2.08,5.02-2.08h152.95c3.92,0,7.1,3.19,7.1,7.11v144.72
		c0,14.1,11.47,25.57,25.57,25.57h284.21c3.92,0,7.11,3.19,7.11,7.11v6c0,5.1,4.13,9.23,9.23,9.23s9.23-4.13,9.23-9.23v-6
		c0-14.1-11.47-25.57-25.57-25.57H456.54c-3.92,0-7.11-3.19-7.11-7.1v-28.62c1.72-0.1,3.43-0.65,4.92-1.74l217.28-158.71
		c0.64,18.22,13.86,33.28,31.25,36.69l-15.47,45.79c-4.23,12.51-2.41,26.57,4.87,37.63c7.03,10.69,18.24,17.4,30.74,18.41
		c1.17,0.1,2.34,0.14,3.53,0.14c23.75,0,43.07-19.32,43.07-43.07v-22.46c0-5.1-4.13-9.23-9.23-9.23s-9.23,4.13-9.23,9.23v22.46
		c0,13.56-11.03,24.6-24.6,24.6c-0.68,0-1.35-0.03-2.03-0.08c-6.9-0.56-12.88-4.17-16.82-10.16c-4.17-6.34-5.22-14.4-2.8-21.56
		l17.88-52.93c0.01-0.04,0.02-0.08,0.03-0.12c15.28-5.21,26.31-19.67,26.31-36.69c0-21.39-17.4-38.78-38.78-38.78
		c-7.3,0-14.1,2.06-19.94,5.58c-0.84,0.03-1.68,0.13-2.51,0.4l-238.6,76.1c-1.22-12.98-12.16-23.17-25.45-23.17H270.91
		c-6.83,0-13.25,2.66-18.08,7.49l-93.49,93.49c-1.02,1.02-2.31,1.7-4.03,2.02l-133.4,29.27C9.8,277.32,1,287.89,1,300.22v117.54
		c0,14.1,11.47,25.57,25.57,25.57H74c5.1,0,9.23-4.13,9.23-9.23C83.24,429,79.11,424.87,74,424.87z M710.35,102.37
		c11.2,0,20.32,9.12,20.32,20.32s-9.12,20.32-20.32,20.32c-11.2,0-20.32-9.12-20.32-20.32S699.15,102.37,710.35,102.37z
		 M449.43,185.33l189.93-60.58L449.43,263.48V185.33z M19.47,334.44h39.75v5.66c0,1.44-0.8,2.75-2.08,3.41
		c-0.2,0.1-0.4,0.21-0.59,0.33l-37.08,22.67V334.44z"
        />
        <path
          d="M566.17,361.9c-34.38,0-62.82,25.66-67.35,58.81H278.67c-5.1,0-9.23,4.13-9.23,9.23c0,5.1,4.13,9.23,9.23,9.23h220.16
		c4.53,33.16,32.96,58.81,67.35,58.81c37.52,0,68.05-30.53,68.05-68.05S603.69,361.9,566.17,361.9z M566.17,479.53
		c-27.34,0-49.58-22.24-49.58-49.58s22.24-49.58,49.58-49.58s49.58,22.24,49.58,49.58S593.51,479.53,566.17,479.53z"
        />
        <path
          d="M172.44,361.9c-37.52,0-68.05,30.53-68.05,68.05S134.92,498,172.44,498s68.05-30.53,68.05-68.05S209.96,361.9,172.44,361.9
		z M172.44,479.53c-27.34,0-49.58-22.24-49.58-49.58s22.24-49.58,49.58-49.58s49.58,22.24,49.58,49.58S199.78,479.53,172.44,479.53z
		"
        />
        <path
          d="M389.19,265.88c0-5.1-4.13-9.23-9.23-9.23l-129.13,0c-0.23,0-0.55-0.01-0.84-0.75c-0.1-0.24-0.52-1.49,0.41-2.39
		l37.25-36.03c3.66-3.55,3.76-9.39,0.22-13.06c-3.55-3.66-9.39-3.76-13.06-0.22l-37.25,36.03c-5.98,5.79-7.85,14.61-4.74,22.45
		c2.98,7.54,9.78,12.3,17.41,12.42c0.16,0.01,0.52,0.01,0.68,0.01h129.07C385.06,275.12,389.19,270.98,389.19,265.88z"
        />
        <path
          d="M773.43,384.43h-77.86c-5.1,0-9.23,4.13-9.23,9.23s4.13,9.23,9.23,9.23H748c-0.08,0.48-0.15,0.97-0.15,1.47v13.39
		c0,3.92-3.19,7.11-7.11,7.11h-74.92c-5.1,0-9.23,4.13-9.23,9.23c0,5.1,4.13,9.23,9.23,9.23h74.92c14.1,0,25.57-11.47,25.57-25.57
		v-13.39c0-0.5-0.07-0.99-0.15-1.47h7.25c3.92,0,7.11,3.19,7.11,7.11v21.4c0,5.1,4.13,9.23,9.23,9.23s9.23-4.13,9.23-9.23v-21.4
		C799,395.91,787.53,384.43,773.43,384.43z"
        />
      </g>
    </svg>
  );
}

export function MonsterTruck(props) {
  return (
    <svg
      id="Monster_Truck"
      data-name="Monster Truck"
      xmlns="http://www.w3.org/2000/svg"
      width="81.887"
      height="45.483"
      viewBox="0 0 800 530"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-786.1 -50)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M740.8,191.5c3.9,0,7.1,3.2,7.1,7.1v65.1c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2v-65.1c0-14.1-11.5-25.6-25.6-25.6H456.5
		c-3.9,0-7.1-3.2-7.1-7.1V80.3c0-14.1-11.5-25.6-25.6-25.6h-153c-6.8,0-13.3,2.7-18.1,7.5l-93.5,93.5c-1,1-2.3,1.7-4,2L21.9,187
		C9.8,189.2,1,199.8,1,212.1v117.5c0,14.1,11.5,25.6,25.6,25.6h45c-2.2,8.5-3.4,17.5-3.6,26.6c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3
		c0,0.4,0,0.8,0,1.2c0,62.9,51.2,114.1,114.1,114.1s114.1-51.2,114.1-114.1S245,269.7,182.1,269.7c-0.4,0-0.8,0-1.2,0
		c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-45.6,0.8-84.8,28.4-102.3,67.8c-1.2-0.5-2.4-0.8-3.8-0.8H26.6c-3.9,0-7.1-3.2-7.1-7.1
		v-30.4c1.1-0.2,2.2-0.5,3.2-1.1l43.3-26.5c7.3-3.9,11.8-11.4,11.8-19.7v-8.4c0-8.7-7.1-15.8-15.8-15.8H19.5v-15.8
		c0-3.4,2.4-6.4,6.1-7L159,175.8c5.1-0.9,9.7-3.4,13.4-7.1l93.5-93.5c1.3-1.3,3.1-2.1,5-2.1h153c3.9,0,7.1,3.2,7.1,7.1v85.6
		c0,14.1,11.5,25.6,25.6,25.6H740.8z M108.2,323.1l8.4,8.4c1.8,1.8,4.2,2.7,6.5,2.7s4.7-0.9,6.5-2.7c3.6-3.6,3.6-9.5,0-13.1
		l-8.4-8.4c13.9-11.5,31.2-19.1,50.1-21.2v12.3c0,5.1,4.1,9.2,9.2,9.2s9.2-4.1,9.2-9.2v-12.6c19.3,1.6,37,8.9,51.4,20.2l-9.7,9.7
		c-3.6,3.6-3.6,9.5,0,13.1c1.8,1.8,4.2,2.7,6.5,2.7s4.7-0.9,6.5-2.7l9.9-9.9c12.2,14.2,20.4,32,22.6,51.6h-15.3
		c-5.1,0-9.2,4.1-9.2,9.2c0,5.1,4.1,9.2,9.2,9.2h15.5c-1.6,20-9.4,38.3-21.5,53l-11.3-11.3c-3.6-3.6-9.5-3.6-13.1,0
		c-3.6,3.6-3.6,9.5,0,13.1l11.3,11.3c-14.7,12.1-33,19.9-53,21.5v-15.5c0-5.1-4.1-9.2-9.2-9.2s-9.2,4.1-9.2,9.2v15.3
		c-19.6-2.2-37.4-10.3-51.6-22.6l9.9-9.9c3.6-3.6,3.6-9.5,0-13.1c-3.6-3.6-9.5-3.6-13.1,0L107,443c-11.3-14.4-18.6-32.1-20.2-51.4
		h12.6c5.1,0,9.2-4.1,9.2-9.2c0-5.1-4.1-9.2-9.2-9.2H87C89.1,354.3,96.7,337,108.2,323.1z M59.2,246.4v5.7c0,1.4-0.8,2.8-2.1,3.4
		c-0.2,0.1-0.4,0.2-0.6,0.3l-37.1,22.7v-32.1H59.2z"
        />
        <path
          d="M287.6,129.4c3.7-3.5,3.8-9.4,0.2-13.1c-3.5-3.7-9.4-3.8-13.1-0.2l-37.2,36c-6,5.8-7.8,14.6-4.7,22.4
		c3,7.5,9.8,12.3,18.1,12.4H380c5.1,0,9.2-4.1,9.2-9.2c0-5.1-4.1-9.2-9.2-9.2H250.8c-0.2,0-0.6,0-0.8-0.8c-0.1-0.2-0.5-1.5,0.4-2.4
		L287.6,129.4z"
        />
        <path
          d="M773.4,296.4h-77.9c-5.1,0-9.2,4.1-9.2,9.2c0,5.1,4.1,9.2,9.2,9.2H748c-0.1,0.5-0.1,1-0.1,1.5v13.4c0,3.9-3.2,7.1-7.1,7.1
		h-70.6c-18-39.5-57.8-67-103.9-67c-0.4,0-0.8,0-1.2,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0c-61.4,1-111.1,50.7-112.1,112.1
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.3c0,0.4,0,0.8,0,1.2c0,62.9,51.2,114.1,114.1,114.1s114.1-51.2,114.1-114.1
		c0-9.9-1.3-19.5-3.6-28.6h64c14.1,0,25.6-11.5,25.6-25.6v-13.4c0-0.5-0.1-1-0.1-1.5h7.3c3.9,0,7.1,3.2,7.1,7.1v21.4
		c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2v-21.4C799,307.8,787.5,296.4,773.4,296.4z M646,391.6h15.5c-1.6,20-9.4,38.3-21.5,53
		l-11.3-11.3c-3.6-3.6-9.5-3.6-13.1,0c-3.6,3.6-3.6,9.5,0,13.1l11.3,11.3c-14.7,12.1-33,19.9-53,21.5v-15.5c0-5.1-4.1-9.2-9.2-9.2
		c-5.1,0-9.2,4.1-9.2,9.2v15.3c-19.6-2.2-37.4-10.3-51.6-22.6l9.9-9.9c3.6-3.6,3.6-9.5,0-13.1c-3.6-3.6-9.5-3.6-13.1,0l-9.7,9.7
		c-11.3-14.4-18.6-32.1-20.2-51.4h12.6c5.1,0,9.2-4.1,9.2-9.2c0-5.1-4.1-9.2-9.2-9.2h-12.3c2.1-18.9,9.7-36.1,21.2-50.1l8.4,8.4
		c1.8,1.8,4.2,2.7,6.5,2.7s4.7-0.9,6.5-2.7c3.6-3.6,3.6-9.5,0-13.1l-8.4-8.4c13.9-11.5,31.2-19.1,50.1-21.2v12.3
		c0,5.1,4.1,9.2,9.2,9.2c5.1,0,9.2-4.1,9.2-9.2v-12.6c19.3,1.6,37,8.9,51.4,20.2l-9.7,9.7c-3.6,3.6-3.6,9.5,0,13.1
		c1.8,1.8,4.2,2.7,6.5,2.7c2.4,0,4.7-0.9,6.5-2.7l9.9-9.9c12.2,14.2,20.4,32,22.6,51.6H646c-5.1,0-9.2,4.1-9.2,9.2
		C636.8,387.5,640.9,391.6,646,391.6z"
        />
        <path
          d="M434.8,296.6c-1.9-4.7-7.3-7-12-5.1l-49.2,20l-49.2-20c-4.7-1.9-10.1,0.3-12,5.1c-1.9,4.7,0.3,10.1,5.1,12l31.7,12.9
		l-31.7,12.9c-4.7,1.9-7,7.3-5.1,12c1.5,3.6,4.9,5.8,8.6,5.8c1.2,0,2.3-0.2,3.5-0.7l49.2-20l49.2,20c1.1,0.5,2.3,0.7,3.5,0.7
		c3.6,0,7.1-2.2,8.6-5.8c1.9-4.7-0.3-10.1-5.1-12L398,321.5l31.7-12.9C434.4,306.7,436.7,301.3,434.8,296.6z"
        />
      </g>
    </svg>
  );
}

export function LiftTruck(props) {
  return (
    <svg id="Lift_Truck" data-name="Lift Truck" xmlns="http://www.w3.org/2000/svg" width="81.887" height="45.483" viewBox="0 0 800 530" fill={props.fill ? props.fill : '#5e72e4'}>
      <g transform="scale(-1 1) translate(-786.1 -50)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M575.4,380.05c-32.52,0-58.98,26.46-58.98,58.98S542.88,498,575.4,498c32.52,0,58.98-26.46,58.98-58.98
		S607.92,380.05,575.4,380.05z M575.4,481.86c-23.62,0-42.84-19.22-42.84-42.84s19.22-42.84,42.84-42.84
		c23.62,0,42.84,19.22,42.84,42.84S599.02,481.86,575.4,481.86z"
        />
        <path
          d="M433.35,380.05c-31.7,0-57.57,25.17-58.86,56.56H229.67c-1.79,0-3.24-1.45-3.24-3.24V150.55c0-1.79,1.45-3.24,3.24-3.24
		h481.48c1.79,0,3.24,1.45,3.24,3.24v54.17c0,4.46,3.61,8.07,8.07,8.07c4.46,0,8.07-3.61,8.07-8.07v-54.17
		c0-10.69-8.7-19.38-19.38-19.38H229.67c-10.69,0-19.38,8.7-19.38,19.38v48.49h-96.7c-8.56,0-16,5.5-18.53,13.68l-18.68,60.72
		c-0.27,0.88-0.91,1.61-1.74,2l-62.38,28.79C5.42,307.38,1,314.29,1,321.82v105.89c0,10.69,8.7,19.38,19.38,19.38h44.87
		C69.21,475.8,93.84,498,123.61,498c32.52,0,58.98-26.46,58.98-58.98s-26.46-58.98-58.98-58.98c-29.78,0-54.4,22.2-58.36,50.91
		H20.38c-1.79,0-3.24-1.45-3.24-3.24v-18.37l40.39-20.79c6.49-3.34,10.51-9.94,10.51-17.24v-7.24c0-7.57-6.16-13.73-13.73-13.73
		H17.14v-28.53c0-1.26,0.74-2.41,1.88-2.94l62.38-28.79c4.99-2.31,8.78-6.64,10.4-11.9l18.68-60.72c0.42-1.37,1.67-2.29,3.1-2.29
		h96.7v80.02H142c-1.79,0-3.24-1.45-3.24-3.24v-11.32c0-4.46-3.61-8.07-8.07-8.07c-4.46,0-8.07,3.61-8.07,8.07v11.32
		c0,10.69,8.7,19.38,19.38,19.38h68.29v122.02c0,10.69,8.7,19.38,19.38,19.38h146.38c6.21,25.91,29.51,45.25,57.3,45.25
		c32.52,0,58.98-26.46,58.98-58.98S465.87,380.05,433.35,380.05z M123.61,396.19c23.62,0,42.84,19.22,42.84,42.84
		s-19.22,42.84-42.84,42.84s-42.84-19.22-42.84-42.84S99.99,396.19,123.61,396.19z M51.91,366.49v4.83c0,1.22-0.67,2.33-1.76,2.88
		l-33.01,16.99v-24.7H51.91z M433.35,481.86c-23.62,0-42.84-19.22-42.84-42.84s19.22-42.84,42.84-42.84s42.84,19.22,42.84,42.84
		S456.97,481.86,433.35,481.86z"
        />
        <path
          d="M790.93,396.34h-60.39V257.49c0-4.46-3.61-8.07-8.07-8.07c-4.46,0-8.07,3.61-8.07,8.07v175.87c0,1.79-1.45,3.24-3.24,3.24
		h-46.66c-4.46,0-8.07,3.61-8.07,8.07c0,4.46,3.61,8.07,8.07,8.07h46.66c10.69,0,19.38-8.7,19.38-19.38v-20.88h60.39
		c4.46,0,8.07-3.61,8.07-8.07C799,399.96,795.39,396.34,790.93,396.34z"
        />
      </g>
    </svg>
  );
}

export function BoxTruck(props) {
  return (
    <svg
      id="Box_Truck"
      data-name="Box Truck"
      xmlns="http://www.w3.org/2000/svg"
      width="77.887"
      height="40.483"
      viewBox="0 0 77.887 40.483"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <path
        id="Path_446"
        data-name="Path 446"
        d="M334.8,608.046l-6.83-3.18-2.034-6.609a2.373,2.373,0,0,0-2.28-1.685H313.4v-5a2.389,2.389,0,0,0-2.386-2.386H260.681a2.389,2.389,0,0,0-2.386,2.386v30.785a2.388,2.388,0,0,0,2.386,2.385h8.928a1.155,1.155,0,0,0,0-2.309h-8.928a.077.077,0,0,1-.077-.076V591.569a.077.077,0,0,1,.077-.077h50.334a.077.077,0,0,1,.077.077v30.785a.077.077,0,0,1-.077.076h-25.04a6.7,6.7,0,1,0-.218,2.309h25.258a2.388,2.388,0,0,0,2.386-2.385V609.347h7.157a2.389,2.389,0,0,0,2.387-2.386V605.73a1.155,1.155,0,0,0-2.309,0v1.232a.077.077,0,0,1-.078.077H313.4V598.88h10.25a.077.077,0,0,1,.073.055l2.034,6.609a2.392,2.392,0,0,0,1.281,1.465l6.789,3.133a.077.077,0,0,1,.045.07v2.829H330.1a1.772,1.772,0,0,0-1.77,1.77v.788a2.375,2.375,0,0,0,1.294,2.121l4.247,2.186v1.832a.077.077,0,0,1-.077.076h-4.647a6.7,6.7,0,1,0,0,2.309H333.8a2.388,2.388,0,0,0,2.386-2.385V610.213A2.394,2.394,0,0,0,334.8,608.046Zm-55.49,19.311a4.387,4.387,0,1,1,4.387-4.387A4.392,4.392,0,0,1,279.306,627.357Zm43.254,0a4.387,4.387,0,1,1,4.386-4.387A4.392,4.392,0,0,1,322.56,627.357Zm11.313-10.047-3.191-1.642a.078.078,0,0,1-.041-.068v-.249h3.232Z"
        transform="translate(-258.295 -589.183)"
      />
    </svg>
  );
}

export function Trailer(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Truck_and_Trailer"
      alt="Truck and Trailer"
      width="81.325"
      height="45.275"
      data-name="Truck and Trailer"
      viewBox="0 0 53.215 20.85"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <path
        id="Path_584"
        d="M993.44 307.626v-3.766a.854.854 0 1 0-1.708 0v2.26H952.39a1.668 1.668 0 0 0-1.681 1.651v9.754h-3.783v-2.215a.854.854 0 1 0-1.708 0v2.215h-1.125a.854.854 0 0 0 0 1.708h8.146c.05 0 .1.015.151.015h12.637a4.948 4.948 0 0 0 9.873 0h1.552a4.948 4.948 0 0 0 9.873 0h5.451a1.668 1.668 0 0 0 1.679-1.653v-9.825c-.001-.047-.011-.095-.015-.144zm-21.276 13.656l-.053.048a3.316 3.316 0 0 1-.411.31l-.064.039a3.262 3.262 0 0 1-.465.234l-.063.023a3.183 3.183 0 0 1-.521.151l-.045.007a3.243 3.243 0 0 1-.58.055 3.232 3.232 0 0 1-.579-.055l-.046-.007a3.22 3.22 0 0 1-.518-.15l-.066-.024a3.24 3.24 0 0 1-.461-.232l-.068-.042a3.179 3.179 0 0 1-.407-.306l-.058-.052a3.249 3.249 0 0 1-.348-.376l-.042-.055a3.272 3.272 0 0 1-.282-.444l-.022-.046a3.289 3.289 0 0 1-.208-.512v-.017a3.24 3.24 0 0 1-.117-.575 3.192 3.192 0 0 1 .3-1.739 3.241 3.241 0 0 1 .493-.746l.007-.008a3.437 3.437 0 0 1 .312-.309 3.259 3.259 0 0 1 .35-.262l.032-.019a3.273 3.273 0 0 1 .333-.184l.067-.032a3.272 3.272 0 0 1 .39-.148l.047-.012a3.28 3.28 0 0 1 .359-.08l.108-.017a3.27 3.27 0 0 1 .424-.031 3.282 3.282 0 0 1 .425.031l.106.017a3.189 3.189 0 0 1 .363.081l.043.011a3.169 3.169 0 0 1 .393.149l.062.03a3.276 3.276 0 0 1 .341.188l.026.016a3.266 3.266 0 0 1 .671.58 3.221 3.221 0 0 1 .675 3.076v.007a3.234 3.234 0 0 1-.212.521l-.018.038a3.171 3.171 0 0 1-.286.45l-.037.05a3.236 3.236 0 0 1-.351.368zm12.451-2.032a3.243 3.243 0 0 1-.119.583v.011a3.261 3.261 0 0 1-.21.517l-.021.042a3.166 3.166 0 0 1-.285.447l-.039.052a3.233 3.233 0 0 1-.35.379l-.055.05a3.269 3.269 0 0 1-.409.309l-.065.04a3.178 3.178 0 0 1-.464.233l-.064.024a3.245 3.245 0 0 1-.519.15l-.045.007a3.1 3.1 0 0 1-1.16 0l-.045-.007a3.218 3.218 0 0 1-.519-.15l-.064-.024a3.172 3.172 0 0 1-.464-.233l-.066-.04a3.218 3.218 0 0 1-.408-.309l-.056-.05a3.243 3.243 0 0 1-.35-.379l-.039-.052a3.233 3.233 0 0 1-.285-.447l-.02-.042a3.261 3.261 0 0 1-.21-.517v-.011a3.243 3.243 0 0 1-.118-.583 3.337 3.337 0 0 1-.019-.347 3.227 3.227 0 0 1 .813-2.141 3.286 3.286 0 0 1 .316-.313 3.228 3.228 0 0 1 .351-.264l.028-.018a3.18 3.18 0 0 1 .338-.186.754.754 0 0 1 .064-.031 3.15 3.15 0 0 1 .391-.149l.045-.012a3.287 3.287 0 0 1 .362-.08l.107-.017a2.953 2.953 0 0 1 .85 0l.107.017a3.293 3.293 0 0 1 .362.08l.045.012a3.143 3.143 0 0 1 .391.149l.065.031a3.223 3.223 0 0 1 .337.186l.029.018a3.178 3.178 0 0 1 .351.264 3.2 3.2 0 0 1 .316.313v.005a3.235 3.235 0 0 1 .495.749 3.22 3.22 0 0 1 .318 1.391 3.371 3.371 0 0 1-.019.347zm7.1-1.739h-5.576a4.95 4.95 0 0 0-9.5 0h-1.921a4.95 4.95 0 0 0-9.5 0h-12.77v-9.653h39.268z"
        className="cls-1"
        data-name="Path 584"
        // transform="translate(-943.239 -303.006)"
        transform="scale(-1 1) translate(-993.239 -301.506)"
      />
    </svg>
  );
}

export function EnclosedTrailer(props) {
  return (
    <svg
      id="Enclosed_Trailer"
      data-name="Enclosed Trailer"
      xmlns="http://www.w3.org/2000/svg"
      width="75.887"
      height="41.483"
      viewBox="0 0 800 520"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-786.1 0)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M777.26,21.39h-638.1c-11.99,0-21.74,9.56-21.74,21.31v361.11c0,1.03,0.1,2.04,0.25,3.04H50.05v-38.61
		c0-5.05-4.09-9.14-9.14-9.14s-9.14,4.09-9.14,9.14v38.61H10.14c-5.05,0-9.14,4.09-9.14,9.14c0,5.05,4.09,9.14,9.14,9.14h129.02
		h251.62c0.55,39.72,33,71.88,72.85,71.88c40.19,0,72.9-32.7,72.9-72.9s-32.7-72.9-72.9-72.9c-34.24,0-62.97,23.76-70.75,55.64
		h-42.26V102.57c0-5.05-4.09-9.14-9.14-9.14H198.33c-5.05,0-9.14,4.09-9.14,9.14v304.28h-50.03c-1.91,0-3.47-1.36-3.47-3.04V42.7
		c0-1.67,1.56-3.04,3.47-3.04h638.1c1.91,0,3.47,1.36,3.47,3.04v361.11c0,1.67-1.56,3.04-3.47,3.04h-35.33
		c-5.05,0-9.14,4.09-9.14,9.14c0,5.05,4.09,9.14,9.14,9.14h35.33c11.99,0,21.74-9.56,21.74-21.31V42.7
		C799,30.96,789.25,21.39,777.26,21.39z M463.63,369.48c30.12,0,54.63,24.5,54.63,54.62c0,30.12-24.51,54.63-54.63,54.63
		c-30.12,0-54.63-24.51-54.63-54.63C409,393.98,433.51,369.48,463.63,369.48z M207.47,111.7h124.89v295.14H207.47V111.7z"
        />
        <path
          d="M624.42,351.21c-40.19,0-72.9,32.7-72.9,72.9s32.7,72.9,72.9,72.9s72.9-32.7,72.9-72.9S664.62,351.21,624.42,351.21z
		 M624.42,478.73c-30.12,0-54.63-24.51-54.63-54.63c0-30.12,24.51-54.62,54.63-54.62s54.63,24.5,54.63,54.62
		C679.05,454.22,654.54,478.73,624.42,478.73z"
        />
      </g>
    </svg>
  );
}

export function GooseneckTrailer(props) {
  return (
    <svg
      id="Gooseneck_Trailer"
      data-name="Gooseneck Trailer"
      xmlns="http://www.w3.org/2000/svg"
      width="75.887"
      height="41.483"
      viewBox="0 0 800 520"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-786.1 -150)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M798.8,368.85c-0.02-5.29-4.32-9.57-9.61-9.57h-61.52c-5.31,0-9.61,4.3-9.61,9.61s4.3,9.61,9.61,9.61h51.95l0.11,26.65
		h-35.2c-5.31,0-9.61,4.3-9.61,9.61c0,5.31,4.3,9.61,9.61,9.61h44.86c2.56,0,5.01-1.02,6.81-2.83c1.8-1.81,2.81-4.27,2.8-6.82
		L798.8,368.85z"
        />
        <path
          d="M620.9,346.61c-36.03,0-66.25,25-74.44,58.54H135.78v-23.07h361.2c5.31,0,9.61-4.3,9.61-9.61c0-5.31-4.3-9.61-9.61-9.61
		h-361.2v-59.48c0-5.31-4.3-9.61-9.61-9.61H10.61c-5.31,0-9.61,4.3-9.61,9.61v36.47c0,5.31,4.3,9.61,9.61,9.61s9.61-4.3,9.61-9.61
		v-26.86h96.33v155.87c0,5.31,4.3,9.61,9.61,9.61c5.31,0,9.61-4.3,9.61-9.61v-44.48h34.6v44.22c0,5.31,4.3,9.61,9.61,9.61
		s9.61-4.3,9.61-9.61v-44.22h354.65c0.58,41.79,34.72,75.63,76.64,75.63c42.29,0,76.7-34.41,76.7-76.7S663.19,346.61,620.9,346.61z
		 M620.9,480.78c-31.69,0-57.47-25.78-57.47-57.47c0-1.82,0.11-3.61,0.27-5.39c0.35-0.99,0.57-2.04,0.57-3.15
		c0-0.19-0.04-0.36-0.05-0.54c4.38-27.38,28.09-48.38,56.68-48.38c31.69,0,57.47,25.78,57.47,57.47S652.59,480.78,620.9,480.78z"
        />
      </g>
    </svg>
  );
}

export function DumpTrailer(props) {
  return (
    <svg
      id="Dump_Trailer"
      data-name="Dump Trailer"
      xmlns="http://www.w3.org/2000/svg"
      width="75.887"
      height="41.483"
      viewBox="0 0 800 520"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-786.1 0)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M559.73,359.45c-38.75,0-70.28,31.52-70.28,70.27S520.98,500,559.73,500c38.75,0,70.28-31.53,70.28-70.28
		S598.48,359.45,559.73,359.45z M559.73,482.39c-29.04,0-52.66-23.63-52.66-52.66c0-29.04,23.63-52.66,52.66-52.66
		c29.04,0,52.66,23.62,52.66,52.66C612.39,458.76,588.77,482.39,559.73,482.39z"
        />
        <path
          d="M394.15,359.45c-33.01,0-60.7,22.91-68.21,53.64H48.28v-37.22c0-4.86-3.94-8.81-8.81-8.81s-8.81,3.94-8.81,8.81v37.22H9.81
		c-4.86,0-8.81,3.94-8.81,8.81c0,4.86,3.94,8.81,8.81,8.81h314.11c0.53,38.29,31.81,69.3,70.23,69.3
		c38.75,0,70.28-31.53,70.28-70.28S432.9,359.45,394.15,359.45z M394.15,482.39c-29.04,0-52.66-23.63-52.66-52.66
		c0-29.04,23.63-52.66,52.66-52.66s52.66,23.62,52.66,52.66C446.81,458.76,423.18,482.39,394.15,482.39z"
        />
        <path
          d="M797.83,190.96c-1.17-2.03-3.09-3.51-5.34-4.12L159.9,16.25c-4.7-1.26-9.52,1.51-10.8,6.2l-48.38,178.52
		c-0.61,2.26-0.3,4.66,0.86,6.69c1.16,2.03,3.08,3.51,5.34,4.12l133.74,36.24c-1.25,1.13-2.19,2.63-2.63,4.38l-17.45,69.64
		c-0.8,3.19,0.24,6.55,2.7,8.73l57.75,51.19c1.68,1.49,3.76,2.22,5.84,2.22c2.43,0,4.85-1,6.6-2.97c3.23-3.64,2.89-9.21-0.75-12.43
		l-53.75-47.64l16.15-64.45c0.41-1.64,0.31-3.29-0.17-4.79l97.79,26.5l386.79,103.99c0.77,0.21,1.54,0.31,2.29,0.31
		c3.88,0,7.43-2.58,8.49-6.51l48.38-178.52C799.31,195.4,798.99,192.99,797.83,190.96z M735.61,363.08L357.34,261.38l-237.3-64.3
		L163.8,35.54l615.58,166.01L735.61,363.08z"
        />
        <path
          d="M747.42,414.44h-79.29c-4.86,0-8.81,3.94-8.81,8.81c0,4.86,3.94,8.81,8.81,8.81h79.29c4.86,0,8.81-3.94,8.81-8.81
		C756.23,418.38,752.29,414.44,747.42,414.44z"
        />
      </g>
    </svg>
  );
}

export function CarHauler(props) {
  return (
    <svg id="Car_Hauler" data-name="Car Hauler" xmlns="http://www.w3.org/2000/svg" width="75.887" height="41.483" viewBox="0 0 790 498" fill={props.fill ? props.fill : '#5e72e4'}>
      <g transform="scale(-1 1) translate(-786.1 0)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M788.23,337.68c-0.02,0-0.03,0-0.05,0l-622.21,3.37v-41.96c0-5.06-4.1-9.15-9.15-9.15H10.15c-5.06,0-9.15,4.1-9.15,9.15
		s4.1,9.15,9.15,9.15h137.51v80.91c0,3.21,1.66,6.03,4.17,7.66c1.67,1.75,4.01,2.85,6.61,2.85h265.96
		c-9.75,10.56-15.76,24.62-15.76,40.1c0,32.66,26.57,59.23,59.23,59.23c32.66,0,59.23-26.57,59.23-59.23s-26.57-59.23-59.23-59.23
		c-5.43,0-10.67,0.8-15.67,2.17c-1.38-0.84-2.98-1.34-4.72-1.34H165.97v-22.01l602.62-3.26l-21.07,25.27h-49.42
		c-5.06,0-9.15,4.1-9.15,9.15c0,5.06,4.1,9.15,9.15,9.15h53.71c2.72,0,5.29-1.21,7.03-3.29l36.43-43.68
		c2.28-2.74,2.77-6.55,1.25-9.77C795,339.72,791.77,337.68,788.23,337.68z M508.8,439.77c0,22.57-18.36,40.92-40.93,40.92
		c-22.57,0-40.92-18.36-40.92-40.92c0-22.57,18.36-40.92,40.92-40.92C490.44,398.84,508.8,417.2,508.8,439.77z"
        />
        <path
          d="M608.81,380.54c-32.66,0-59.23,26.57-59.23,59.23S576.15,499,608.81,499s59.23-26.57,59.23-59.23
		S641.47,380.54,608.81,380.54z M608.81,480.69c-22.57,0-40.92-18.36-40.92-40.92c0-22.57,18.36-40.92,40.92-40.92
		s40.92,18.36,40.92,40.92C649.74,462.33,631.38,480.69,608.81,480.69z"
        />
        <path
          d="M777.02,140.9l-121.63-24.93c-0.65-0.11-1.27-0.35-1.82-0.7l-91.89-93.64c-0.28-0.28-0.57-0.55-0.89-0.79
		c-4.05-3.17-9.11-4.92-14.25-4.92H213.92c-0.05,0-0.33,0-0.38,0c-7.61,0.13-14.42,4.25-18.2,11.03
		c-3.94,7.06-3.85,15.73,0.25,22.63l9.6,16.16c2.58,4.34,8.2,5.77,12.55,3.19c4.35-2.58,5.78-8.2,3.19-12.55l-9.6-16.16
		c-0.92-1.56-0.61-3.26,0-4.35c0.6-1.08,1.45-1.63,2.6-1.65h332.62c0.92,0,1.83,0.27,2.6,0.77l91.9,93.64
		c0.28,0.29,0.58,0.55,0.89,0.8c3.03,2.37,6.64,3.96,10.11,4.53l121.64,24.93c2.32,0.39,4.01,2.38,4.01,4.73v6.95h-28.52
		c-8.13,0-14.74,6.61-14.74,14.74v7.15c0,7.51,4.08,14.33,10.68,17.89l32.58,19.91v23.94c0,2.65-2.15,4.8-4.8,4.8h-56.17
		c-4.42-28.41-28.98-50.24-58.61-50.24c-32.75,0-59.39,26.64-59.39,59.39c0,32.75,26.64,59.39,59.39,59.39
		c29.63,0,54.18-21.83,58.61-50.24h56.17c12.74,0,23.11-10.37,23.11-23.11v-90.57C796,152.29,787.88,142.7,777.02,140.9z
		 M658.12,309.24c-22.65,0-41.08-18.43-41.08-41.08c0-22.66,18.43-41.08,41.08-41.08c22.65,0,41.08,18.43,41.08,41.08
		C699.2,290.81,680.77,309.24,658.12,309.24z M754.42,194.59c-0.19-0.12-0.38-0.23-0.58-0.33c-0.68-0.35-1.1-1.03-1.1-1.79v-3.58
		h24.95v19.92L754.42,194.59z"
        />
        <path
          d="M195.99,273.31h34.82c5.06,0,9.15-4.1,9.15-9.15c0-5.06-4.1-9.15-9.15-9.15h-34.82c-2.65,0-4.8-2.15-4.8-4.8v-80.53
		c0-1.25,0.48-2.43,1.34-3.33c0.21-0.22,0.41-0.45,0.6-0.68l62.93-79.83c3.13-3.97,2.45-9.73-1.52-12.85
		c-3.97-3.14-9.73-2.46-12.86,1.52L179,154.02c-3.95,4.28-6.12,9.82-6.12,15.66v80.53C172.88,262.95,183.25,273.31,195.99,273.31z"
        />
        <path
          d="M265.42,268.16c0,32.75,26.64,59.39,59.39,59.39c29.63,0,54.18-21.83,58.61-50.24h186.96c5.06,0,9.15-4.1,9.15-9.15
		c0-5.06-4.1-9.15-9.15-9.15H383.42c-4.42-28.41-28.98-50.24-58.61-50.24C292.06,208.77,265.42,235.41,265.42,268.16z
		 M324.81,227.08c22.65,0,41.08,18.43,41.08,41.08c0,22.65-18.43,41.08-41.08,41.08c-22.65,0-41.08-18.43-41.08-41.08
		C283.73,245.5,302.16,227.08,324.81,227.08z"
        />
        <path
          d="M451.32,108.94c-5.06,0-9.15,4.1-9.15,9.15s4.1,9.15,9.15,9.15H561.9c7.31-0.12,13.56-4.5,16.29-11.42
		c2.84-7.18,1.13-15.25-4.35-20.55l-31.81-30.78c-3.63-3.51-9.43-3.42-12.94,0.21c-3.51,3.63-3.42,9.43,0.21,12.94l31.81,30.78
		c0.14,0.13,0.13,0.34,0.1,0.51H451.32z"
        />
        <path
          d="M382.26,127.24c12.74,0,23.11-10.37,23.11-23.11V71.07c0-5.06-4.1-9.15-9.15-9.15s-9.15,4.1-9.15,9.15v33.06
		c0,2.65-2.15,4.8-4.8,4.8h-79.48c-5.06,0-9.15,4.1-9.15,9.15s4.1,9.15,9.15,9.15H382.26z"
        />
      </g>
    </svg>
  );
}

export function Float53FeetAsGooseneckTrailer(props) {
  return (
    <svg
      id="Float_53_Feet"
      data-name="Float 53 Feet"
      xmlns="http://www.w3.org/2000/svg"
      width="75.887"
      height="41.483"
      viewBox="0 0 800 520"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-786.1 -150)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M798.81,374.88c-0.02-5.05-4.12-9.13-9.17-9.13h-51.35c-5.07,0-9.17,4.11-9.17,9.17s4.11,9.17,9.17,9.17h42.22l0.11,25.42
		h-26.25c-5.07,0-9.17,4.11-9.17,9.17c0,5.07,4.11,9.17,9.17,9.17h35.46c2.44,0,4.78-0.97,6.5-2.7c1.72-1.73,2.68-4.07,2.67-6.51
		L798.81,374.88z"
        />
        <path
          d="M482.36,353.66c-34.37,0-63.2,23.85-71.01,55.85h-2.71h-200.6h-41.77V387.5h212.55c5.07,0,9.17-4.11,9.17-9.17
		c0-5.07-4.11-9.17-9.17-9.17H166.27v-42.07c0-5.07-4.11-9.17-9.17-9.17H10.17c-5.07,0-9.17,4.11-9.17,9.17
		c0,5.07,4.11,9.17,9.17,9.17h137.75v143.99h-14.79c-5.07,0-9.17,4.11-9.17,9.17c0,5.07,4.11,9.17,9.17,9.17h47.92
		c5.07,0,9.17-4.11,9.17-9.17c0-5.07-4.11-9.17-9.17-9.17h-14.79v-52.4h41.77h200.6h0.61c0.55,39.87,33.12,72.15,73.12,72.15
		c40.35,0,73.17-32.83,73.17-73.17S522.71,353.66,482.36,353.66z M482.36,481.66c-30.23,0-54.83-24.6-54.83-54.83
		c0-30.23,24.6-54.83,54.83-54.83c30.23,0,54.83,24.59,54.83,54.83C537.19,457.06,512.59,481.66,482.36,481.66z"
        />
        <path
          d="M643.76,353.66c-40.35,0-73.17,32.82-73.17,73.17S603.41,500,643.76,500c40.35,0,73.17-32.83,73.17-73.17
		S684.1,353.66,643.76,353.66z M643.76,481.66c-30.23,0-54.83-24.6-54.83-54.83c0-30.23,24.6-54.83,54.83-54.83
		c30.23,0,54.83,24.59,54.83,54.83C698.59,457.06,673.99,481.66,643.76,481.66z"
        />
      </g>
    </svg>
  );
}

export function Wheeler18DryVan(props) {
  return (
    <svg
      id="18_Wheeler_Dry_Van"
      data-name="18 Wheeler Dry Van"
      xmlns="http://www.w3.org/2000/svg"
      width="81.887"
      height="48.483"
      viewBox="0 0 1000 490"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-886.1 -20)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M789.92,314.52H504V59.56h285.93c5.01,0,9.08-4.06,9.08-9.08s-4.06-9.08-9.08-9.08h-295c-5.01,0-9.08,4.06-9.08,9.08V323.6
		c0,5.01,4.06,9.08,9.08,9.08h295c5.01,0,9.08-4.06,9.08-9.08C799,318.59,794.94,314.52,789.92,314.52z"
        />
        <path
          d="M739.8,117.97v144.93c0,5.01,4.06,9.08,9.08,9.08c5.01,0,9.08-4.06,9.08-9.08V117.97c0-5.01-4.06-9.08-9.08-9.08
		C743.86,108.9,739.8,112.96,739.8,117.97z"
        />
        <path
          d="M654.31,117.97v144.93c0,5.01,4.06,9.08,9.08,9.08c5.01,0,9.08-4.06,9.08-9.08V117.97c0-5.01-4.06-9.08-9.08-9.08
		C658.37,108.9,654.31,112.96,654.31,117.97z"
        />
        <path
          d="M568.82,117.97v144.93c0,5.01,4.06,9.08,9.08,9.08c5.01,0,9.08-4.06,9.08-9.08V117.97c0-5.01-4.06-9.08-9.08-9.08
		C572.89,108.9,568.82,112.96,568.82,117.97z"
        />
        <path
          d="M227.18,197.14h-72.09c-5.01,0-9.08,4.06-9.08,9.08v56.23c0,5.01,4.06,9.08,9.08,9.08h72.09c5.01,0,9.08-4.06,9.08-9.08
		v-56.23C236.26,201.2,232.2,197.14,227.18,197.14z M218.1,253.36h-53.93v-38.07h53.93V253.36z"
        />
        <path
          d="M152.45,359.3c-35.88,0-65.52,27.02-69.77,61.78H19.16V375.3l47.64-23.36C74.83,348.49,80,341.21,80,333.29v-7.48
		c0-8.22-7.34-14.91-16.36-14.91H19.16v-17.78l98.77-26.09c3.98-1.05,6.76-4.66,6.76-8.78v-84.03h100.74c5.01,0,9.08-4.06,9.08-9.08
		v-30.61h37.09c5.01,0,9.08-4.06,9.08-9.08v-5.9c0-20.45,13.9-38.05,33.79-42.8l103.13-24.61V323.6c0,5.01,4.06,9.08,9.08,9.08
		c5.01,0,9.08-4.06,9.08-9.08V40.63c0-2.78-1.27-5.4-3.45-7.12c-2.18-1.72-5.04-2.35-7.73-1.71L310.25,59.09
		c-27.07,6.46-46.28,29.76-47.66,57.28h-27.66v-35c0-11.96,4.66-23.22,13.12-31.68l20.77-20.77c3.55-3.55,3.55-9.29,0-12.84
		s-9.29-3.55-12.84,0l-20.77,20.77c-11.89,11.89-18.44,27.7-18.44,44.51v41.44c-0.26,0.84-0.44,1.72-0.44,2.64v30.61H115.6
		c-5.01,0-9.08,4.06-9.08,9.08v86.12L7.76,277.35C3.78,278.41,1,282.01,1,286.13v144.02c0,5.01,4.06,9.08,9.08,9.08h72.76
		c4.7,34.26,34.09,60.77,69.62,60.77c38.79,0,70.35-31.56,70.35-70.35S191.24,359.3,152.45,359.3z M61.85,329.06v4.23
		c0,0.37-0.67,1.33-2.29,2c-0.18,0.07-0.35,0.15-0.53,0.24l-39.88,19.55v-26.02H61.85z M152.45,481.84
		c-28.78,0-52.19-23.41-52.19-52.19s23.41-52.19,52.19-52.19s52.19,23.41,52.19,52.19S181.23,481.84,152.45,481.84z"
        />
        <path
          d="M515.49,359.3c-35.71,0-65.22,26.76-69.7,61.27H262.41c-5.01,0-9.08,4.06-9.08,9.08s4.06,9.08,9.08,9.08H445.8
		c4.48,34.51,33.99,61.27,69.7,61.27c38.79,0,70.35-31.56,70.35-70.35S554.28,359.3,515.49,359.3z M515.49,481.84
		c-28.78,0-52.19-23.41-52.19-52.19s23.41-52.19,52.19-52.19c28.78,0,52.19,23.41,52.19,52.19S544.27,481.84,515.49,481.84z"
        />
        <path
          d="M789.92,420.57h-40.94c-3.25,0-6.07,1.72-7.68,4.28c-2.48-36.55-32.94-65.55-70.11-65.55c-38.79,0-70.35,31.56-70.35,70.35
		S632.41,500,671.2,500c37.17,0,67.62-29,70.11-65.55c1.6,2.56,4.43,4.28,7.68,4.28h40.94c5.01,0,9.08-4.06,9.08-9.08
		S794.94,420.57,789.92,420.57z M671.2,481.84c-28.78,0-52.2-23.41-52.2-52.19s23.41-52.19,52.2-52.19
		c28.78,0,52.19,23.41,52.19,52.19S699.98,481.84,671.2,481.84z"
        />
      </g>
    </svg>
  );
}

export function Wheeler18FlatBed(props) {
  return (
    <svg
      id="18_Wheeler_Flat_Bed"
      data-name="18 Wheeler Flat Bed"
      xmlns="http://www.w3.org/2000/svg"
      width="81.887"
      height="48.483"
      viewBox="0 0 1000 490"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-886.1 -20)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <g>
          <g>
            <g>
              <path
                d="M90.21,439.23H10.08c-5.01,0-9.08-4.06-9.08-9.08V286.13c0-4.12,2.78-7.72,6.76-8.78l98.77-26.09v-86.12
					c0-5.01,4.06-9.08,9.08-9.08h100.74v-30.61c0-5.01,4.06-9.08,9.08-9.08h37.17c1.38-27.52,20.58-50.82,47.66-57.28L424.56,31.8
					c2.69-0.65,5.55-0.02,7.73,1.71c2.18,1.72,3.45,4.34,3.45,7.12V323.6c0,5.01-4.06,9.08-9.08,9.08c-5.01,0-9.08-4.06-9.08-9.08
					V52.13L314.46,76.75c-19.89,4.75-33.79,22.35-33.79,42.8v5.9c0,5.01-4.06,9.08-9.08,9.08H234.5v30.61
					c0,5.01-4.06,9.08-9.08,9.08H124.68v84.03c0,4.12-2.78,7.72-6.76,8.78l-98.77,26.09v127.96h71.06c5.01,0,9.08,4.06,9.08,9.08
					S95.23,439.23,90.21,439.23z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M789.92,332.68h-295c-5.01,0-9.08-4.06-9.08-9.08c0-5.01,4.06-9.08,9.08-9.08h295c5.01,0,9.08,4.06,9.08,9.08
					C799,328.62,794.94,332.68,789.92,332.68z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M789.92,292.74h-295c-5.01,0-9.08-4.06-9.08-9.08V146.6c0-5.01,4.06-9.08,9.08-9.08s9.08,4.06,9.08,9.08v127.98h285.93
					c5.01,0,9.08,4.06,9.08,9.08C799,288.67,794.94,292.74,789.92,292.74z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M227.18,271.52h-72.09c-5.01,0-9.08-4.06-9.08-9.08v-56.23c0-5.01,4.06-9.08,9.08-9.08h72.09
					c5.01,0,9.08,4.06,9.08,9.08v56.23C236.26,267.45,232.2,271.52,227.18,271.52z M164.17,253.36h53.93v-38.07h-53.93V253.36z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M152.45,500c-38.79,0-70.35-31.56-70.35-70.35s31.56-70.35,70.35-70.35s70.35,31.56,70.35,70.35S191.24,500,152.45,500z
					 M152.45,377.46c-28.78,0-52.19,23.41-52.19,52.19s23.41,52.19,52.19,52.19s52.19-23.41,52.19-52.19
					S181.23,377.46,152.45,377.46z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M515.49,500c-38.79,0-70.35-31.56-70.35-70.35s31.56-70.35,70.35-70.35c38.79,0,70.35,31.56,70.35,70.35
					S554.28,500,515.49,500z M515.49,377.46c-28.78,0-52.19,23.41-52.19,52.19s23.41,52.19,52.19,52.19
					c28.78,0,52.19-23.41,52.19-52.19S544.27,377.46,515.49,377.46z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M671.2,500c-38.79,0-70.35-31.56-70.35-70.35s31.56-70.35,70.35-70.35c38.79,0,70.35,31.56,70.35,70.35
					S709.99,500,671.2,500z M671.2,377.46c-28.78,0-52.2,23.41-52.2,52.19s23.41,52.19,52.2,52.19c28.78,0,52.19-23.41,52.19-52.19
					S699.98,377.46,671.2,377.46z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M14.51,376.54c-3.35,0-6.58-1.87-8.16-5.09c-2.21-4.5-0.34-9.94,4.16-12.15l48.52-23.79c0.17-0.09,0.35-0.16,0.53-0.24
					c1.62-0.67,2.29-1.63,2.29-2v-4.23H14.51c-5.01,0-9.08-4.06-9.08-9.08c0-5.01,4.06-9.08,9.08-9.08h49.14
					c9.02,0,16.36,6.69,16.36,14.91v7.48c0,7.92-5.17,15.21-13.21,18.65L18.5,375.62C17.22,376.24,15.85,376.54,14.51,376.54z
					 M63.65,329.06h0.04H63.65z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M225.86,134.53c-5.01,0-9.08-4.06-9.08-9.08V81.37c0-16.82,6.55-32.62,18.44-44.51l20.77-20.77
					c3.55-3.55,9.29-3.55,12.84,0s3.55,9.29,0,12.84l-20.77,20.77c-8.46,8.46-13.12,19.71-13.12,31.68v44.08
					C234.94,130.46,230.87,134.53,225.86,134.53z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M454.22,438.73H262.41c-5.01,0-9.08-4.06-9.08-9.08s4.06-9.08,9.08-9.08h191.81c5.01,0,9.08,4.06,9.08,9.08
					S459.24,438.73,454.22,438.73z"
              />
            </g>
          </g>
        </g>
        <g>
          <g>
            <g>
              <path
                d="M789.92,438.73h-40.94c-5.01,0-9.08-4.06-9.08-9.08s4.06-9.08,9.08-9.08h40.94c5.01,0,9.08,4.06,9.08,9.08
					S794.94,438.73,789.92,438.73z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export function Wheeler18Reefer(props) {
  return (
    <svg
      id="18_Wheeler_Reefer"
      data-name="18 Wheeler Reefer"
      xmlns="http://www.w3.org/2000/svg"
      width="81.887"
      height="48.483"
      viewBox="0 0 970 490"
      fill={props.fill ? props.fill : '#5e72e4'}
    >
      <g transform="scale(-1 1) translate(-886.1 -20)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="14px">
        <path
          d="M777.8,96.74H251.13c-11.69,0-21.2,9.51-21.2,21.2v53.04H124.15c-9.36,0-17.51,6.01-20.27,14.97l-20.43,66.42
		c-0.3,0.97-0.99,1.76-1.91,2.18l-68.23,31.49C5.83,289.49,1,297.05,1,305.29v115.83c0,11.69,9.51,21.2,21.2,21.2h49.08
		c4.33,31.4,31.27,55.68,63.84,55.68c35.57,0,64.51-28.94,64.51-64.51s-28.94-64.51-64.51-64.51c-32.57,0-59.51,24.28-63.84,55.68
		H22.2c-1.96,0-3.55-1.59-3.55-3.55v-20.1l44.18-22.74c7.09-3.65,11.5-10.87,11.5-18.85v-7.92c0-8.28-6.74-15.02-15.02-15.02H18.66
		v-31.2c0-1.38,0.81-2.64,2.06-3.22l68.23-31.49c5.46-2.52,9.61-7.27,11.38-13.01l20.43-66.42c0.46-1.5,1.82-2.5,3.39-2.5h105.78
		v87.53h-74.7c-1.96,0-3.55-1.59-3.55-3.55v-12.38c0-4.88-3.95-8.83-8.83-8.83s-8.83,3.95-8.83,8.83v12.38
		c0,11.69,9.51,21.2,21.2,21.2h74.7V427.3c0,11.69,9.51,21.2,21.2,21.2h326.09c6.79,28.34,32.28,49.5,62.68,49.5
		c35.57,0,64.51-28.94,64.51-64.51s-28.94-64.51-64.51-64.51c-34.68,0-62.98,27.53-64.38,61.87H251.13c-1.96,0-3.55-1.59-3.55-3.55
		V117.94c0-1.96,1.59-3.55,3.55-3.55H777.8c1.96,0,3.55,1.59,3.55,3.55v59.26c0,4.88,3.95,8.83,8.83,8.83s8.83-3.95,8.83-8.83
		v-59.26C799,106.25,789.49,96.74,777.8,96.74z M135.12,386.63c25.84,0,46.86,21.02,46.86,46.86c0,25.84-21.02,46.86-46.86,46.86
		s-46.86-21.02-46.86-46.86C88.26,407.65,109.28,386.63,135.12,386.63z M56.69,354.15v5.28c0,1.33-0.74,2.55-1.92,3.16l-36.1,18.58
		v-27.02H56.69z M639.9,386.63c25.84,0,46.86,21.02,46.86,46.86c0,25.84-21.02,46.86-46.86,46.86c-25.84,0-46.86-21.02-46.86-46.86
		C593.04,407.65,614.06,386.63,639.9,386.63z"
        />
        <path
          d="M790.17,226.09c-4.88,0-8.83,3.95-8.83,8.83V427.3c0,1.96-1.59,3.55-3.55,3.55h-40.45c-4.88,0-8.83,3.95-8.83,8.83
		c0,4.88,3.95,8.83,8.83,8.83h40.45c11.69,0,21.2-9.51,21.2-21.2V234.92C799,230.05,795.05,226.09,790.17,226.09z"
        />
        <path
          d="M622.86,225.48c-2.76-2.76-7.23-2.76-9.99,0l-34.88,34.88h-47.46l22.01-22.01h26.49c3.9,0,7.06-3.16,7.06-7.06
		c0-3.9-3.16-7.06-7.06-7.06H558.4v-20.62c0-3.9-3.16-7.06-7.06-7.06s-7.06,3.16-7.06,7.06v23.37c-0.49,0.29-0.97,0.63-1.39,1.05
		l-22.85,22.85v-44.07c0-1.26-0.36-2.43-0.94-3.46l35.83-35.83c2.76-2.76,2.76-7.23,0-9.99c-2.76-2.76-7.23-2.76-9.99,0
		l-26.33,26.33v-21.33c0-3.9-3.16-7.06-7.06-7.06s-7.06,3.16-7.06,7.06v21.33l-26.32-26.33c-2.76-2.76-7.23-2.76-9.99,0
		c-2.76,2.76-2.76,7.23,0,9.99l37.88,37.88c-0.09,0.45-0.14,0.92-0.14,1.4v46.93l-27.1-27.1v-23.03c0-3.9-3.16-7.06-7.06-7.06
		s-7.06,3.16-7.06,7.06v20.62h-20.62c-3.9,0-7.06,3.16-7.06,7.06c0,3.9,3.16,7.06,7.06,7.06h26.49l22,22.01H449.5
		c-1.26,0-2.43,0.36-3.46,0.94l-35.83-35.82c-2.76-2.76-7.23-2.76-9.99,0c-2.76,2.76-2.76,7.23,0,9.99l26.32,26.32h-21.33
		c-3.9,0-7.06,3.16-7.06,7.06c0,3.9,3.16,7.06,7.06,7.06h21.33l-26.32,26.33c-2.76,2.76-2.76,7.23,0,9.99
		c1.38,1.38,3.19,2.07,4.99,2.07c1.81,0,3.62-0.69,4.99-2.07l37.88-37.88c0.45,0.09,0.92,0.14,1.41,0.14h46.93l-29.33,29.33h-23.03
		c-3.9,0-7.06,3.16-7.06,7.06c0,3.9,3.16,7.06,7.06,7.06h20.62v20.62c0,3.9,3.16,7.06,7.06,7.06s7.06-3.16,7.06-7.06v-26.49
		l27.1-27.1v47.46l-37.74,37.74c-2.76,2.76-2.76,7.23,0,9.99c1.38,1.38,3.19,2.07,4.99,2.07s3.62-0.69,4.99-2.07l26.32-26.33v21.33
		c0,3.9,3.16,7.06,7.06,7.06s7.06-3.16,7.06-7.06v-21.33l26.33,26.33c2.76,2.76,7.23,2.76,9.99,0c2.76-2.76,2.76-7.23,0-9.99
		l-34.88-34.88v-47.46l24.24,24.24v26.49c0,3.9,3.16,7.06,7.06,7.06s7.06-3.16,7.06-7.06v-20.62h20.62c3.9,0,7.06-3.16,7.06-7.06
		c0-3.9-3.16-7.06-7.06-7.06h-23.37c-0.29-0.49-0.63-0.97-1.05-1.39l-27.94-27.94h48.48l37.74,37.74c1.38,1.38,3.19,2.07,4.99,2.07
		c1.81,0,3.62-0.69,4.99-2.07c2.76-2.76,2.76-7.23,0-9.99l-26.32-26.33h21.33c3.9,0,7.06-3.16,7.06-7.06c0-3.9-3.16-7.06-7.06-7.06
		h-21.33l26.32-26.32C625.62,232.71,625.62,228.24,622.86,225.48z"
        />
      </g>
    </svg>
  );
}

export function SprinterVan(props) {
  return (
    <svg
      id="Sprinter_Van"
      data-name="Sprinter Van"
      xmlns="http://www.w3.org/2000/svg"
      width="85.887"
      height="43"
      viewBox="0 0 200 170"
      fill={props.fill ? props.fill : '#5e72e4'}
      fillOpacity="0"
    >
      <g transform="translate(-100 -170)" stroke={props.fill ? props.fill : '#5e72e4'} strokeWidth="9px">
        <path d="M 148.979 296.449 L 260.973 297.295" />
        <path d="M 155.944 277.109 L 257.552 276.838" />
        <path d="M 75.635 299.543 L 103.408 299.261" />
        <line x1="87.118" y1="204.645" x2="227.887" y2="201.613" />
        <path d="M 76.38 299.964 C 76.38 299.964 67.50819192286984 299.2365559150589 65.549 296.764 C 63.4899866060692 294.1654665501011 64.843 284.31 64.843 284.31" />
        <line x1="65.029" y1="283.863" x2="66.703" y2="219.345" />
        <path d="M 87.367 204.633 C 87.367 204.633 73.53126312254248 203.52210565413603 70.209 206.493 C 67.1849567246416 209.19721478884392 67.095 220.449 67.095 220.449" />
        <path d="M 226.654 201.709 C 226.654 201.709 248.42131958969483 200.49258520574222 258.533 204.949 C 270.58816643974666 210.26194699687858 279.6826643058493 227.0999350410927 292.504 235.285 C 305.7170797126072 243.7201520258727 327.56327324366504 244.98064302981447 336.915 254.451 C 344.4195946899517 262.05079333038753 347.86646684991865 275.5474681187144 348.896 283.204 C 349.5407110048962 287.998649266819 349.80624583344223 292.6689567105083 347.343 295.32 C 344.3748717117077 298.514417899423 334.9308297918319 298.2640928452532 329.964 298.859 C 326.30053611074715 299.2977951611422 320.322 299.221 320.322 299.221" />
        <ellipse cx="127.914" cy="289.915" rx="21.613" ry="21.601" />
        <path d="M 67.845 277.383 L 100.186 277.314" />
        <path d="M 249.589 213.821 L 281.904 245.919" />
        <path d="M 281.959 245.8 C 281.959 245.8 261.1164466169351 247.15004841379215 252.092 245.877 C 244.32930669277673 244.78194289334377 230.871 239.709 230.871 239.709" />
        <path d="M 345.231 267.458 C 345.231 267.458 325.73614075892567 267.64141168076367 325.073 270.156 C 324.40079570746633 272.70495667231233 337.15570563780614 281.058001620058 341.725 282.782 C 344.3582631045693 283.77553225386396 348.647 283.287 348.647 283.287" />
        <ellipse cx="297.955" cy="289.517" rx="21.613" ry="21.601" />
      </g>
    </svg>
  );
}

export function StoreFront(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1920" height="1202" viewBox="0 0 1920 1202" fill={props.fill ? props.fill : '#f7941d'}>
      <path id="Rectangle_1664" d="M0 0h1920v1202H0z" data-name="Rectangle 1664" />
    </svg>
  );
}
